declare global {
  interface Window {
    dataLayer?: object[]
  }
}

export const sendGtmEvent = (event: object) => {
  if (typeof window === 'undefined') {
    return
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(event)
}

export const getQuizUserId = (): string | undefined => {
  if (typeof document === 'undefined') {
    return undefined
  }

  return document.cookie
    .split('; ')
    .find((row) => row.startsWith('cUserId='))
    ?.split('=')[1]
}

type TrackModalOpenEventProps = {
  pageName: string
  modalSlug: string
  source: string
  section?: string
}

// Generic page-level modal open. `pageName` is supplied where the modal provider
// is instantiated, so the event isn't tied to any one page; `source` is where the
// open came from (e.g. 'ingredients-accordion', 'faq', 'deep-link').
export const trackModalOpenEvent = ({ pageName, modalSlug, source, section = 'pdp' }: TrackModalOpenEventProps) => {
  const userId = getQuizUserId()
  sendGtmEvent({
    event: 'user_click',
    click_type: 'modal',
    section,
    page_name: pageName,
    link_position: source,
    link_text_image: modalSlug,
    modal_id: modalSlug,
    ...(userId && { user_id: userId }),
  })
}
